import React from 'react';

let fareDateCellRenders = 0;

export function readFareDateCellRenders() {
  return fareDateCellRenders;
}

export function resetFareDateCellRenders() {
  fareDateCellRenders = 0;
}

/**
 * One day in the fare calendar. Memoized so a tap only re-renders the days whose role or price changed.
 */
const FareDateCell = React.memo(function FareDateCell({
  iso,
  day,
  disabled,
  priceLabel,
  priceColor,
  role,
  onPick,
}) {
  fareDateCellRenders += 1;
  const handleClick = () => {
    if (!disabled) onPick(iso);
  };
  return (
    <button
      type="button"
      className={`fare-date-cell fare-date-cell--${role || 'plain'}`}
      data-date={iso}
      disabled={disabled}
      aria-pressed={role === 'selected' || role === 'range-start' || role === 'range-end' || role === 'range-single'}
      onClick={handleClick}
    >
      <span className="fare-date-cell-day">{day}</span>
      {priceLabel ? (
        <span className="fare-date-cell-price" style={priceColor ? { color: priceColor } : undefined}>
          {priceLabel}
        </span>
      ) : null}
    </button>
  );
});

export default FareDateCell;
